import ExternalLink from 'components/organisms/ExternalLink';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { applyLocaleToPath } from 'routing/paths';
import { useLang } from '~/stores/i18n';

interface MenuItemLinkProps {
  isExternalLink?: boolean;
  url?: string;
  addReturnTo?: boolean;
  text: React.ReactNode;
  openModal?: boolean;
  openInNewTab?: boolean;
  noAuth?: boolean;
  testId?: string;
  onClick?: () => void;
  className?: string;
}

function MenuItemLink({
  isExternalLink,
  url,
  addReturnTo,
  text,
  openModal,
  openInNewTab,
  noAuth,
  testId,
  ...rest
}: MenuItemLinkProps) {
  const location = useLocation();
  const lang = useLang();
  if (!url) {
    return (
      <button
        type="button"
        onClick={rest.onClick}
        data-test-id={testId}
        {...rest}
      >
        {text}
      </button>
    );
  }

  if (isExternalLink) {
    return (
      <ExternalLink
        url={url}
        openInNewTab={openInNewTab}
        noAuth={noAuth}
        rel="noopener noreferrer"
        data-test-id={testId}
        {...rest}
      >
        {text}
      </ExternalLink>
    );
  }

  const searchParams = new URLSearchParams();
  if (addReturnTo) {
    const returnTo = location.pathname + location.search;
    searchParams.set('returnTo', returnTo);
  }

  const to = {
    pathname: openModal ? url : applyLocaleToPath(url, lang),
    search: searchParams.toString(),
  };

  return (
    <Link
      to={to}
      state={{ modal: openModal }}
      rel="noopener noreferrer"
      data-test-id={testId}
      {...rest}
    >
      {text}
    </Link>
  );
}

export default MenuItemLink;
